// extracted by mini-css-extract-plugin
export default {"highlight":"HighlightText_highlight__7Jc+U"};